import { type EmailTemplateFormListingFragment } from '@graphql/__generated__/graphql';
import {
  RichEditorValue,
  appendHtml,
  escapeText,
  withSnippet,
} from '@modules/_shared/components/email-editor';
import { getListingLotSnippetEntityData } from '@modules/_shared/utils/email';
import {
  type BuildListingDefaultEmailTemplate,
  useListingDefaultEmailTemplate,
} from '@modules/_shared/utils/listingDefaultEmailTemplate';
import type { Language, Translate } from '@shared/hooks/locale';

export const buildMatchedBuyerLeadEmailTemplate: BuildListingDefaultEmailTemplate =
  ({ listing, brochureTemplateId, language, t }) => {
    const lotSnippetData = getListingLotSnippetEntityData(
      listing,
      brochureTemplateId,
      language,
    );

    const htmlStr = `<p>${t('Dear Sir or Madam,')}</p><br/><p>${t(
      'Based on your search criteria, we think the following property might interest you.',
    )}</p><br/>`;

    let body = RichEditorValue.createFromString(htmlStr, 'html');
    body = withSnippet(body, lotSnippetData);
    body = appendHtml(
      body,
      `<br/><p>${t(
        "Would you like to schedule a visit or receive more details? Don't hesitate to contact us.",
      )}</p>`,
    );

    const subjectText =
      listing.title?.trim() || t('A property that might interest you');

    return {
      subject: RichEditorValue.createFromString(
        escapeText(subjectText),
        'html',
      ),
      text: body,
    };
  };

export const useMatchedBuyerLeadEmailTemplate = (params: {
  listing: EmailTemplateFormListingFragment | null;
  language: Language;
  t: Translate;
  skip: boolean;
}) =>
  useListingDefaultEmailTemplate({
    ...params,
    build: buildMatchedBuyerLeadEmailTemplate,
  });
